
; (function () {
    angular.module("EMR.PreBillReportPopup", []);


    var PreBillReportPopupRoutes = [
        {
            "name": "PreBillReportPopup",
            "templateUrl": "<div emr-pre-bill-report-filters-popup></div>",
            "RoutingNumber": 4254,
            files: [
                "AngularScripts/PreBillReportPopup/Directives/PreBillReportFiltersPopupDirective.js",
            ]
        }
    ];



    angular.module('EMR.PreBillReportPopup')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(PreBillReportPopupRoutes, $stateProvider);
            }]);
})();